let inactivityTimer;
let countdownInterval;
let countdownTimerActive = false;

const INACTIVITY_LIMIT = 30 * 60 * 1000;
const COUNTDOWN_LIMIT = 3 * 60 * 1000;

let timeLeft = COUNTDOWN_LIMIT;
let onTickCallback = null;
let onCountdownCallback = null;
let onResetCallback = null;

// Main starter
function startInactivityTimer(onTick, onCountdown, onReset) {
  onTickCallback = onTick;
  onCountdownCallback = onCountdown;
  onResetCallback = onReset;

  window.addEventListener("mousemove", handleActivity);
  window.addEventListener("keydown", handleActivity);
  window.addEventListener("click", handleActivity);
  window.addEventListener("scroll", handleActivity);

  resetInactivityTimer();
}

function handleActivity() {
  if (!countdownTimerActive) {
    resetInactivityTimer();
  }
}

// Just resets the timer — countdown not started yet
function resetInactivityTimer() {
  clearTimeout(inactivityTimer);
  clearInterval(countdownInterval);

  timeLeft = COUNTDOWN_LIMIT;
  countdownTimerActive = false;

  // This is key: start countdown only after inactivity delay
  inactivityTimer = setTimeout(() => {
    startCountdown();
  }, INACTIVITY_LIMIT);
}

function startCountdown() {
  countdownTimerActive = true;
  if (onCountdownCallback) {
    onCountdownCallback(true); // Show countdown modal
  }

  countdownInterval = setInterval(() => {
    timeLeft -= 1000;
    if (onTickCallback) {
      onTickCallback(timeLeft);
    }

    if (timeLeft <= 0) {
      clearInterval(countdownInterval);
      logout();
    }
  }, 1000);
}

function logout() {
  localStorage.removeItem("vecima_full_name");
  localStorage.removeItem("vecima_token");
  localStorage.removeItem("vecima_user");
  localStorage.removeItem("vecima_user_picture");
  window.location.reload();
}

function stopInactivityTimer() {
  clearTimeout(inactivityTimer);
  clearInterval(countdownInterval);
  window.removeEventListener("mousemove", handleActivity);
  window.removeEventListener("keydown", handleActivity);
  window.removeEventListener("click", handleActivity);
  window.removeEventListener("scroll", handleActivity);
}

function resetSession() {
  clearTimeout(inactivityTimer);
  clearInterval(countdownInterval);
  timeLeft = COUNTDOWN_LIMIT;
  countdownTimerActive = false;

  if (onTickCallback) {
    setTimeout(() => {
      onTickCallback(COUNTDOWN_LIMIT);
    }, 500);
  }

  if (onResetCallback) {
    onResetCallback();
  }
}

export { startInactivityTimer, stopInactivityTimer, resetSession };
